<select appSelect
        [attr.aria-label]="labelId"
        [mmTestTarget]="mmTestTarget"
        (selectChanged)="onSelectChange($event)"
        class="mm-select"
        [ngClass]="{'whiteBg': !(isNewPLPVariantRestyle$ | async) && isPLP}">
  <ng-content></ng-content>
</select>
